import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { cx } from '@emotion/css'
import { arrayOf, oneOf, string } from 'prop-types'
import { useIntl } from 'react-intl'
import Typography from '../../atoms/typography'
import Tooltip from '../../molecules/tooltip'
import { IconComponent } from '../../utils/icons'
import { Root } from './washing-icons.styled'

const WashingIcons = ({ className, icons, variant: _variant }) => {
	const {
		catalog: {
			products: {
				washingIcons: { variant: variantConfig },
			},
		},
	} = useConfig()

	const variant = _variant ?? variantConfig
	const { formatMessage } = useIntl()

	return icons?.length > 0 ? (
		<Root className={cx('WashingIcons-root', className)} variant={variant}>
			{icons.map((code) => {
				const Icon = IconComponent(`Iso${code}Icon`)
				if (!Icon) return console.warn(`[Washing Icon Renderer] Iso${code}Icon is not a valid icon.`)
				else {
					return variant === 'tooltip' ? (
						<Tooltip key={code} title={formatMessage({ id: `washing_icon_${code}` })}>
							<div>
								<Icon color="primary" fontSize="large" cursor="pointer" />
							</div>
						</Tooltip>
					) : (
						<div key={code}>
							<Icon color="primary" fontSize="large" />
							<Typography component="span" color="primary">
								{formatMessage({ id: `washing_icon_${code}` })}
							</Typography>
						</div>
					)
				}
			})}
		</Root>
	) : null
}

WashingIcons.defaultProps = {
	icons: [],
}

WashingIcons.propTypes = {
	/**
	 * Class name for the root element.
	 */
	className: string,
	/**
	 * Array of ISO Washing Icons.
	 * @see [ISO ref.](https://www.iso.org/standard/42918.html)
	 * @see [Confluence Guide](https://filoblu.atlassian.net/wiki/spaces/TECH/pages/3483238401/Care+labelling+code+using+symbols)
	 */
	icons: arrayOf(string).isRequired,
	/**
	 * View mode for the icons.
	 */
	variant: oneOf(['tooltip', 'list']),
}

export default WashingIcons
